/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum AppSchemasMembersStatusEnum {
  PendingActivation = 'pending_activation',
  Active = 'active',
  Suspended = 'suspended',
  Deleted = 'deleted'
}
